export default "__VITE_ASSET__Csb464G0__"